import { render, staticRenderFns } from "./info_h5.vue?vue&type=template&id=2e8919c7&scoped=true&"
import script from "./info_h5.vue?vue&type=script&lang=js&"
export * from "./info_h5.vue?vue&type=script&lang=js&"
import style0 from "./info_h5.vue?vue&type=style&index=0&id=2e8919c7&lang=less&scoped=true&"
import style1 from "./info_h5.vue?vue&type=style&index=1&id=2e8919c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8919c7",
  null
  
)

export default component.exports